import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const FilterControls = ({ onFiltersChange, onExport }) => {
  const [dateRange, setDateRange] = useState('7d');
  const [platform, setPlatform] = useState('all');
  const [metric, setMetric] = useState('engagement');

  const dateRangeOptions = [
    { value: '1d', label: 'Last 24 hours' },
    { value: '7d', label: 'Last 7 days' },
    { value: '30d', label: 'Last 30 days' },
    { value: '90d', label: 'Last 3 months' },
    { value: 'custom', label: 'Custom range' }
  ];

  const platformOptions = [
    { value: 'all', label: 'All Platforms' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'twitter', label: 'Twitter' },
    { value: 'facebook', label: 'Facebook' }
  ];

  const metricOptions = [
    { value: 'engagement', label: 'Engagement Rate' },
    { value: 'reach', label: 'Reach' },
    { value: 'impressions', label: 'Impressions' },
    { value: 'clicks', label: 'Click-through Rate' },
    { value: 'conversions', label: 'Conversions' }
  ];

  const handleFilterChange = (filterType, value) => {
    const newFilters = { dateRange, platform, metric };
    newFilters[filterType] = value;
    
    if (filterType === 'dateRange') setDateRange(value);
    if (filterType === 'platform') setPlatform(value);
    if (filterType === 'metric') setMetric(value);
    
    if (onFiltersChange) {
      onFiltersChange(newFilters);
    }
  };

  const handleExport = (format) => {
    if (onExport) {
      onExport(format, { dateRange, platform, metric });
    }
  };

  const handleRefresh = () => {
    // Simulate data refresh
    if (onFiltersChange) {
      onFiltersChange({ dateRange, platform, metric, refresh: true });
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-soft mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
          <Select
            label="Date Range"
            options={dateRangeOptions}
            value={dateRange}
            onChange={(value) => handleFilterChange('dateRange', value)}
            className="w-full sm:w-48"
          />
          
          <Select
            label="Platform"
            options={platformOptions}
            value={platform}
            onChange={(value) => handleFilterChange('platform', value)}
            className="w-full sm:w-40"
          />
          
          <Select
            label="Primary Metric"
            options={metricOptions}
            value={metric}
            onChange={(value) => handleFilterChange('metric', value)}
            className="w-full sm:w-48"
          />
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handleRefresh}
            iconName="RefreshCw"
            iconPosition="left"
          >
            Refresh
          </Button>
          
          <div className="relative group">
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
            >
              Export
            </Button>
            
            <div className="absolute right-0 top-full mt-1 w-48 bg-card border border-border rounded-lg shadow-medium opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
              <div className="p-2">
                <button
                  onClick={() => handleExport('pdf')}
                  className="w-full flex items-center space-x-2 px-3 py-2 text-sm text-foreground hover:bg-muted rounded-md transition-micro"
                >
                  <Icon name="FileText" size={16} />
                  <span>Export as PDF</span>
                </button>
                <button
                  onClick={() => handleExport('excel')}
                  className="w-full flex items-center space-x-2 px-3 py-2 text-sm text-foreground hover:bg-muted rounded-md transition-micro"
                >
                  <Icon name="FileSpreadsheet" size={16} />
                  <span>Export as Excel</span>
                </button>
                <button
                  onClick={() => handleExport('csv')}
                  className="w-full flex items-center space-x-2 px-3 py-2 text-sm text-foreground hover:bg-muted rounded-md transition-micro"
                >
                  <Icon name="Database" size={16} />
                  <span>Export as CSV</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;